import { Tabs } from "@components/tabs-nav/TabNav.types";

export const SystemOmniTabs: Tabs = {
  Operations: {
    Reports: { id: "ops-reports", name: "Reports" }
  }
};
